import { Modal } from "semantic-ui-react";
import { ChangePassword } from "../../UserProfile/ChangePassword";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../store/configureStore";
import { setUser } from "../../../actions/authentificationActions";
import "./AdditionalLoginComponents.css";

export const MandatoryPasswordReset = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: AppState) => state.user);

    const updateMandatoryPasswordChange = () => {
        const newUser = { ...structuredClone(user), mandatoryPasswordChange: false };

        dispatch(setUser(newUser));
        sessionStorage.setItem("user", JSON.stringify(newUser));
    };

    return (
        <Modal
            open={user.mandatoryPasswordChange}
            closeOnEscape={false}
            onClose={() => {}}
            size="mini"
            dimmer
            id="modal-reset-password-first-login"
        >
            <Modal.Header>
                <div>You must change your password before continuing to use the application</div>
            </Modal.Header>
            <Modal.Content>
                <ChangePassword user={user} passwordChanged={updateMandatoryPasswordChange} />
            </Modal.Content>
        </Modal>
    );
};
